import styled from "styled-components";
import {
  MwebLoaderWrap,
  MwebOverlayLoader,
  MwebPageRoot,
  MwebScrollArea,
  MwebSpinner,
} from "../CommonLandingMweb/shared/MwebPageShell";

export const PageRoot = MwebPageRoot;

export const ScrollArea = styled(MwebScrollArea)`
  padding-bottom: 96px;
`;

export const ListContent = styled.div`
  padding: 12px 0 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const LoaderWrap = styled(MwebLoaderWrap)`
  min-height: 240px;
`;

export const OverlayLoader = MwebOverlayLoader;

export const InnerFlex = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
`;

export const Spinner = MwebSpinner;
